import { OperationsData, type Role } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const CustomerBriefPage = lazyPage(() => import("../customers/CustomerBriefPage"), "CustomerBriefPage");
const CustomerPresentPage = lazyPage(() => import("../present/CustomerPresentPage"), "CustomerPresentPage");

/**
 * Customer delivery area routes (O-R42, O-R43, D-O71; lob-customer):
 * - /operations/customers/brief?ids=... (wins, troubles, upcoming 30-day deliveries, VIPER narrative, branded PDF, copy for email)
 * - /present/customer?ids=... (customer-safe full-screen presentation view)
 */
export const CustomerLobReaders: readonly Role[] = OperationsData;

export { CustomerBriefPage, CustomerPresentPage };

export const customerRoutes: AreaRoute[] = [
  {
    path: "/operations/customers/brief",
    allow: CustomerLobReaders,
    element: <CustomerBriefPage />
  }
];

/**
 * The present view is shown to customers in a briefing, so it renders outside the application frame (no internal
 * menu, ticker or VIPER launcher); App.tsx mounts it next to the wall display, behind the same readers.
 */
export const customerPresentRoute: AreaRoute = {
  path: "/present/customer",
  allow: CustomerLobReaders,
  element: <CustomerPresentPage />
};
